export enum DatasetCreatorAction {
    RENAME = 'rename',
    UPDATE_TRAINING_METHOD = 'update-training-method',
    UPDATE_TRAINING_METHOD_GO_TO_THE_NEXT_STEP = 'update-training-method-go-to-the-next-step',
}

export enum DatasetCreatorView {
    SET_NAME = 'set-name',
    SET_TRAINING_METHOD = 'set-training-method',
}
